import React from "react";
import { Translation } from "react-i18next";
import "../components/inputField_style.css";


export default function InputFields({ data, onChange, height, value, name, resize = "none" }) {

  return (

    <Translation ns={['translation', 'translation']}>
     {(t) => (
     <div className="input-main-container" style={{ flex: 2 }}>
      <form className="input-container">
        <span className="input-label"> 
        {t(data.translation)}{data.required && <span className="input-label-dot">*</span>}
        </span>
        <input
          type="text"
          name={name}
          className="input-field"
          style={{ height: height, resize: 'none' }}
          onChange={onChange}
          value={value}
        />
      </form>
      </div>
      )}
    </Translation>
  );
}
